import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERM(state, perms) {
    state.cached = perms
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPerms(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/app-perms/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERM', request)
      return request
    })
  },
  fetchPermsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePerms(context, formData) {
    let promise = null
    console.log(formData)
    if (formData._id){
      promise =  axios.put(`${serverUrl}/base/app-perms/${_id}`, formData)
    }else {
      promise =  axios.post(`${serverUrl}/base/app-perms/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deletePerms(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}